import { styled } from '@mui/material/styles';
import type { JSX } from 'react';
import { defaultPadding, paddingMap } from './config.ts';
import type { IndentationProps, PaperPadding, StylesProps } from './types.ts';

const StyledDiv = styled('div')<{ padding: string }>(({ theme, padding }) => ({
  background: theme.palette.background.boxLight,
  margin: `0 -${paddingMap[padding]}px`,

  padding: paddingMap[padding],
}));

export const Indentation = ({ children, className, padding }: IndentationProps & StylesProps): JSX.Element => (
  <StyledDiv padding={padding} className={className}>
    {children}
  </StyledDiv>
);

export const makeIndentation =
  (padding: PaperPadding = defaultPadding) =>
  ({ children, className }: IndentationProps): JSX.Element => (
    <Indentation padding={padding} className={className}>
      {children}
    </Indentation>
  );
